import styles from './styles.module.css'
import { PlayersCreationForm } from '../../widgets/players-creation-form'
import { useCallback, useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { redirectIfNoRefreshToken } from '../../shared/redirects'
import { IconMenu } from '../../widgets/icon-menu'
import { useDispatch } from 'react-redux'
import { setEditableNews } from 'app/store/slices/news'
import { PlayerManipulationService } from 'shared/player/services/player-manipulation-service'
import { setEditablePlayer } from 'app/store/slices/player'
import { clearErrorMessage, clearInfoMessage, showErrorMessage, showInfoMessage } from 'app/store/slices/alerts'
import { TPlayerDeleteMessage } from 'pages/PlayersListPage/types'

const playerManipulationService = PlayerManipulationService()

export function PlayersPage () {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [searchParams] = useSearchParams()
    const playerId = searchParams.get('id')

    const loadNews = async () => {
        if(!playerId){
            return
        }

        const tms = PlayerManipulationService()
        const result = await tms.getPlayer(playerId)

        if(!result.errorMessage){
            dispatch(setEditablePlayer({
                ...result.player,
            }))
        }
    }
    
    useEffect(() => {
        loadNews()
    }, [])

    useEffect(() => {
        redirectIfNoRefreshToken(navigate)
    }, [])

    const deletePlayer = useCallback(async () => {
        if (!playerId) {
          dispatch(showErrorMessage("Отсутствует ID игрока"))
          setTimeout(() => { dispatch(clearErrorMessage()) }, 5000); return
        }
    
        const confirmDelete = confirm(`Вы уверены, что хотите удалить игрока <${playerId}> ?`)
        if (!confirmDelete) {
          return
        }
    
        const playerDeleteMessage: TPlayerDeleteMessage = await playerManipulationService.removePlayer(playerId || '')
        if (playerDeleteMessage.errorMessage) {
          dispatch(showErrorMessage(playerDeleteMessage.errorMessage))
          setTimeout(() => { dispatch(clearErrorMessage()) }, 5000); return
        }
        dispatch(showInfoMessage(`Игрок ${playerId} удален`))
        navigate('/players')
        setTimeout(() => { dispatch(clearInfoMessage()) }, 5000)
    }, [playerId])

    return <div className={styles.PlayerPage}>
        {/* <AdminMenu /> */}
        <div className={styles.ContentContainer}>
            <div className={styles.FormContainer}>
                <IconMenu
                    onSearchClick={() => { navigate('/players') }}
                    onDeleteClick={playerId ? () => deletePlayer() : undefined}
                />
                <PlayersCreationForm />
            </div>
        </div>
    </div>
}
